import "./App.css";
import RenderRandomCube from "./components/RenderRandomCube";

function App() {
  return (
    <div className="app-container">
      <div className="cube">
        <RenderRandomCube />
      </div>
      <p className="coming-soon">Coming Soon</p>
      <footer className="footer">
        <a href="mailto:hello@learnprogramming.blog">hello@learnprogramming.blog</a>
      </footer>
    </div>
  );
}

export default App;
